import React from 'react';
import { IconButton, Skeleton, Tooltip } from '@mui/material';
import ModuleCard from '../../../../appointment/components/moduleCard/ModuleCard';
import styles from './InsuranceDocumentsSection.module.css';

/**
 * Bloco da seção de convênios no mesmo card das carteirinhas: ícone colorido,
 * título, uma linha de apoio e a ação do bloco à direita.
 */
export function DocumentsBlock({ title, hint, icon, accent, actions, children }) {
  return (
    <ModuleCard title={title} icon={icon} description={hint} accent={accent} actions={actions}>
      <div className={styles.blockBody}>{children}</div>
    </ModuleCard>
  );
}

/** Primeira carga: duas linhas em esqueleto no formato das linhas reais. */
export function DocumentsSkeleton({ rows = 2 }) {
  return (
    <div className={styles.card} aria-busy="true" aria-label="Carregando documentos">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className={styles.skeletonRow}>
          <Skeleton variant="rounded" width={40} height={40} sx={{ borderRadius: '12px' }} />
          <div className={styles.skeletonText}>
            <Skeleton variant="text" width="45%" height={18} />
            <Skeleton variant="text" width="30%" height={14} />
          </div>
          <Skeleton variant="rounded" width={88} height={22} sx={{ borderRadius: '999px' }} />
        </div>
      ))}
    </div>
  );
}

/** Ação compacta da linha: ícone com tooltip (o span mantém o tooltip no botão desligado). */
export function RowAction({ title, label, disabled, onClick, Icon, tone }) {
  return (
    <Tooltip title={title} arrow>
      <span>
        <IconButton
          size="small"
          className={`${styles.rowAction} ${tone ? styles[tone] : ''}`}
          onClick={onClick}
          disabled={disabled}
          aria-label={label || title}
        >
          <Icon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
